import React from 'react';
import { Newspaper, ArrowRight, Calendar, User } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';

const BlogPage = () => {
  const posts = [
    { title: 'Como aumentar vendas com chatbots no WhatsApp', date: '15 Jan 2026', author: 'Equipe ChatAlfa', category: 'Estratégia' },
    { title: '10 templates de chatbot que convertem', date: '12 Jan 2026', author: 'Equipe ChatAlfa', category: 'Templates' },
    { title: 'Guia completo de automação para e-commerce', date: '10 Jan 2026', author: 'Equipe ChatAlfa', category: 'E-commerce' },
    { title: 'Integrando ChatGPT ao seu atendimento', date: '08 Jan 2026', author: 'Equipe ChatAlfa', category: 'IA' },
    { title: 'Case: Como a Loja X aumentou 45% em vendas', date: '05 Jan 2026', author: 'Equipe ChatAlfa', category: 'Cases' },
    { title: 'Novidades do ChatAlfa em 2026', date: '02 Jan 2026', author: 'Equipe ChatAlfa', category: 'Produto' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Newspaper className="h-4 w-4" />Blog
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-green-600">Blog</span> ChatAlfa
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">Dicas, estratégias e novidades sobre chatbots e automação.</p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
              <Card key={post.title} className="hover:shadow-lg transition-shadow cursor-pointer group">
                <CardContent className="p-6">
                  <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">{post.category}</span>
                  <h3 className="font-bold text-lg mt-3 mb-2 group-hover:text-green-600 transition-colors">{post.title}</h3>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <span className="flex items-center gap-1"><Calendar className="h-4 w-4" />{post.date}</span>
                    <span className="flex items-center gap-1"><User className="h-4 w-4" />{post.author}</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div className="py-16 text-center">
          <Button variant="outline" size="lg">
            Ver todos os artigos <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default BlogPage;
